<div
  class="flex h-full flex-col gap-4"
  data-testid="enrichment-transition-drawer"
>
  <p class="m-0 text-sm text-gray-700">
    {{ spec().intro }} Channel: <strong>{{ channelLabel() }}</strong>.
  </p>

  @if (readFailed()) {
  <p
    class="m-0 text-sm text-red-700"
    role="alert"
    data-testid="transition-read-failed"
  >
    Could not check the prices' current status. Close this panel and try again.
  </p>
  } @else if (basis() === null) {
  <p class="m-0 text-sm text-gray-500" data-testid="transition-loading">
    Checking the prices' current status…
  </p>
  } @else if (outcomes()) {
  <p
    class="m-0 text-sm font-semibold text-gray-900"
    role="status"
    data-testid="transition-result"
  >
    {{ result() }}
  </p>
  } @else {
  <p
    class="m-0 text-sm font-semibold text-gray-900"
    data-testid="transition-count"
  >
    {{ eligibleCount() }} of {{ selectedCount() }} selected {{ selectedCount()
    === 1 ? "price" : "prices" }} will be {{ spec().done }}.
  </p>
  } @if (groups().length) {
  <section class="flex flex-col gap-2" aria-label="Prices that will change">
    @for (group of groups(); track group.offeringId) {
    <div
      class="rounded-lg border border-gray-200 p-3"
      [attr.data-testid]="'transition-group-' + group.offeringId"
    >
      <div class="flex items-center justify-between gap-2">
        <span class="truncate text-sm font-semibold text-gray-900"
          >{{ group.offeringName }}</span
        >
        @if (group.outcome; as outcome) { @if (outcome.ok) {
        <span class="text-xs font-semibold text-green-700"
          >{{ spec().done }}</span
        >
        } @else {
        <span class="text-xs font-semibold text-red-700">Not changed</span>
        } }
      </div>
      <ul class="m-0 mt-1 flex list-none flex-col gap-0.5 p-0">
        @for (price of group.prices; track price.key) {
        <li class="flex items-center justify-between gap-2 text-sm">
          <span class="truncate">{{ price.title }}</span>
          <code class="text-xs text-gray-500">{{ price.priceId }}</code>
        </li>
        }
      </ul>
      @if (group.outcome?.message; as message) {
      <p
        class="m-0 mt-1 text-xs text-red-700"
        role="alert"
        [attr.data-testid]="'transition-error-' + group.offeringId"
      >
        {{ message }}
      </p>
      }
    </div>
    }
  </section>
  } @if (blocked().length) {
  <section aria-label="Prices that will not change">
    <h4 class="m-0 mb-1 text-xs font-bold text-gray-500 uppercase">
      Not eligible
    </h4>
    <ul class="m-0 flex list-none flex-col gap-1 p-0">
      @for (line of blocked(); track line.key) {
      <li class="text-sm" [attr.data-testid]="'transition-skip-' + line.key">
        <span class="font-medium">{{ line.title }}</span>
        <span class="text-xs text-gray-500"> · {{ line.offeringName }}</span>
        <span class="block text-xs text-amber-700">{{ line.why }}</span>
      </li>
      }
    </ul>
  </section>
  } @if (shared().length) {
  <section aria-label="Prices listed under several product offerings">
    <h4 class="m-0 mb-1 text-xs font-bold text-gray-500 uppercase">
      Shared prices
    </h4>
    <ul class="m-0 flex list-none flex-col gap-1 p-0">
      @for (line of shared(); track line.key) {
      <li
        class="text-xs text-gray-600"
        [attr.data-testid]="'transition-shared-' + line.key"
      >
        <span class="font-medium text-gray-900">{{ line.title }}</span> under {{
        line.offeringName }}. {{ line.why }}.
      </li>
      }
    </ul>
  </section>
  } @if (isSchedule() && !outcomes()) {
  <section class="flex flex-col gap-1">
    <h4 class="m-0 text-xs font-bold text-gray-500 uppercase">
      {{ action() === "scheduleUnpublish" ? "Take off sale at" : "Publish at" }}
    </h4>
    <enr-date-time-picker
      [label]="action() === 'scheduleUnpublish' ? 'take-down time' : 'publish time'"
      [value]="scheduledAt()"
      data-testid="transition-datetime"
      (valueChange)="pickTime($event)"
    />
    <p class="m-0 text-xs text-gray-500">{{ zoneLabel }}</p>
    @if (scheduledAt() && !timeIsFuture()) {
    <p
      class="m-0 text-xs text-red-700"
      role="alert"
      data-testid="transition-past"
    >
      That time has passed. Pick a time in the future.
    </p>
    }
  </section>
  } @if (sending()) {
  <p
    class="m-0 mt-auto text-xs text-gray-500"
    role="status"
    data-testid="transition-sending-note"
  >
    Closing this panel does not stop the change. A message reports the result.
  </p>
  }
  <div class="flex justify-end gap-2" [class.mt-auto]="!sending()">
    <enr-button
      variant="outline"
      size="small"
      data-testid="transition-btn-close"
      (clicked)="close()"
    >
      {{ sending() || outcomes() ? "Close" : "Cancel" }}
    </enr-button>
    @if (!outcomes()) {
    <enr-button
      [variant]="action() === 'reject' ? 'error' : 'primary'"
      size="small"
      [disabled]="!canConfirm()"
      data-testid="transition-btn-confirm"
      (clicked)="confirm()"
    >
      @if (sending()) { Sending… } @else { {{ spec().label }} {{ eligibleCount()
      }} {{ eligibleCount() === 1 ? "price" : "prices" }} }
    </enr-button>
    }
  </div>
</div>
